// extracted by mini-css-extract-plugin
export default {"title":"Iaa-z","warning":"Jaa-z","sizeOptionsLegendText":"Kaa-z"};